import { render, staticRenderFns } from "./dianbofang.vue?vue&type=template&id=1abe37f8&scoped=true"
import script from "./dianbofang.vue?vue&type=script&lang=js"
export * from "./dianbofang.vue?vue&type=script&lang=js"
import style0 from "./dianbofang.vue?vue&type=style&index=0&id=1abe37f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abe37f8",
  null
  
)

export default component.exports